export type AccountingDimension = Readonly<{
    id: number
    name: string
}>

export enum UpdateKeyListAccountNumbers {
    ACCOUNT_NUMBER = "ACCOUNT_NUMBER",
    ACCOUNT_NAME = "ACCOUNT_NAME",
}

export type ImportAccountNumbersFormValues = Readonly<{
    dimensionId: null | number
    updateKey: UpdateKeyListAccountNumbers
    updateMatching: boolean
    deleteUnmatched: boolean
    file: null | Blob
}>
